const USER_ACTIONS = {
  SET_USER: 'USER/SET_USER',
  CLEAR_USER: 'USER/CLEAR_USER',
  SET_JWT: 'USER/SET_JWT',
  UPDATE_HAULER: 'USER/UPDATE_HAULER'
}

export default USER_ACTIONS
